import { expandIcon } from './expandIcon';
export const getExpandable = (expandedRowComponent, expandAllControl, rowExpandable, onExpand, expandRowOnClick, expandedRows, expandedKeys) => {
  return expandedRowComponent ? {
    expandedRowRender: expandedRowComponent,
    expandIcon: expandIcon(expandAllControl, rowExpandable),
    showExpandColumn: expandAllControl === 'uncontrolled',
    expandedRowKeys: expandedRows || expandedKeys,
    onExpand,
    expandRowByClick: expandRowOnClick,
    rowExpandable,
    columnWidth: 48,
    columnTitle: ' '
  } : {
    onExpand,
    expandRowByClick: expandRowOnClick,
    columnWidth: 48
  };
};